import { useState, useEffect, ReactNode } from 'react';
import AuthService from './AuthService'; 
import { User_EXT } from '../../Models/Classes';
import { AuthContext } from './AuthContextState';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
    const [sessionToken, setSessionToken] = useState<string | null>(null);
    const [sessionUser, setSessionUser] = useState<User_EXT | null>(null);

    useEffect(() => {
        const fetchSessionToken = async () => {
            try {
                const token = AuthService.getCurrentUser();
                if (token) {
                    setSessionToken(token.SessionToken);
                    setSessionUser(token.UserInfo);
                }
            } catch (error) {
                console.error('Failed to fetch session token:', error);
            }
        };

        fetchSessionToken();
    }, []);

    return (
        <AuthContext.Provider value={{ sessionToken, setSessionToken, sessionUser, setSessionUser }}>
            {children}
        </AuthContext.Provider>
    );
};

